import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.theskillgenie.com';

/**
 * Fetch all certificates for the authenticated student.
 * 
 * @param {string} studentId - The ID of the student.
 * @returns {Promise<Array>} - Array of certificate objects.
 */
export const fetchCertificatesByStudentId = async (studentId) => {
  if (!studentId) {
    throw new Error('Student ID is required');
  }

  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/certificates/student/${studentId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (response.data.success) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to fetch certificates');
    }
  } catch (error) {
    console.error('Error in fetchCertificatesByStudentId:', error);
    throw error;
  }
};

/**
 * Download a certificate by its ID or PDF URL.
 * 
 * @param {string} pdfUrl - The URL of the certificate PDF.
 */
export const downloadCertificate = (pdfUrl) => {
  if (pdfUrl) {
    window.open(pdfUrl, '_blank');
  }
};
